import Link from "next/link";
import React from "react";

import { useGenerateResetOtpMutation } from "@/graphql/generated/schema";
import toast from "react-hot-toast";
import Button from "@/designs/Button";

export interface StepProp {
  setSteps: () => void;
  email?: string;
  setEmail?: (value: string) => void;
  otp?: string;
  setOTP?: (value: string) => void;
}

const Step1 = ({ setSteps, email, setEmail }: StepProp) => {
  const [generateOTP, { loading }] = useGenerateResetOtpMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); // prevent page reload

    if (!email) {
      toast.error("Please enter your email.");
      return;
    }

    try {
      const { data } = await generateOTP({
        variables: { email },
      });

      const output = data?.generateResetOtp;

      if (output?.user?.id) {
        toast.success(
          "We’ve sent a 4-digit OTP to your email. Please check your inbox (and spam folder)."
        );
        setSteps();
      } else if (output?.error) {
        toast.error(output.error.message || "Something went wrong. Try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Unable to send OTP. Please try again later.");
    }
  };

  return (
    <form className="space-y-5" onSubmit={handleSubmit}>
      <div>
        <label className="block text-sm font-medium  mb-1">
          Email
        </label>
        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail && setEmail(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#004175]"
        />
      </div>

      <div className="text-right text-sm">
        <Link href="/login" className="text-[#004175] hover:underline">
          Already have an account?
        </Link>
      </div>

      <Button type="submit" loading={loading}>
        Send OTP
      </Button>
    </form>
  );
};

export default Step1;
